import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Browser } from '@atlaskit/media-picker';
import PickerFacadeProvider from './PickerFacadeProvider';
export var BrowserWrapper = function BrowserWrapper(_ref) {
  var api = _ref.api,
    isOpen = _ref.isOpen,
    onBrowseFn = _ref.onBrowseFn,
    featureFlags = _ref.featureFlags;
  return /*#__PURE__*/React.createElement(PickerFacadeProvider, {
    api: api,
    analyticsName: "browser"
  }, function (_ref2) {
    var mediaClientConfig = _ref2.mediaClientConfig,
      config = _ref2.config,
      pickerFacadeInstance = _ref2.pickerFacadeInstance;
    var browserConfig = _objectSpread(_objectSpread({}, config), {}, {
      multiple: true
    });
    return /*#__PURE__*/React.createElement(Browser, {
      onBrowseFn: onBrowseFn,
      isOpen: isOpen,
      config: browserConfig,
      mediaClientConfig: mediaClientConfig,
      onEnd: pickerFacadeInstance.handleReady,
      onError: pickerFacadeInstance.handleUploadError,
      onPreviewUpdate: pickerFacadeInstance.handleUploadPreviewUpdate,
      featureFlags: featureFlags
    });
  });
};